export function pluckIds<T>(objects: { id: T }[]): T[] {
  return objects?.map(({ id }) => id);
}

export function pluckId<T>(object: { id: T } | null): T | null {
  return object?.id ?? null;
}
